/** WhatzPro premium SaaS design tokens */
export const theme = {
  colors: {
    primary: '#ff6b6b',
    primaryDark: '#ee5252',
    primaryLight: '#ff8787',
    secondary: '#ff8e53',
    accentGradient: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)',
    accentGradientHover: 'linear-gradient(135deg, #ff5252 0%, #ff7a3d 100%)',
    sidebarFrom: '#0b1220',
    sidebarTo: '#1a2332',
    sidebarAccent: 'rgba(255, 107, 107, 0.14)',
    bg: '#f1f5f9',
    bgMesh:
      'radial-gradient(ellipse 85% 55% at 8% -5%, rgba(255,107,107,0.09) 0%, transparent 52%), radial-gradient(ellipse 70% 45% at 92% 8%, rgba(255,142,83,0.1) 0%, transparent 48%), radial-gradient(ellipse 50% 40% at 50% 100%, rgba(148,163,184,0.06) 0%, transparent 55%), #f1f5f9',
    card: '#ffffff',
    cardHover: '#fafbfc',
    cardBorder: 'rgba(148, 163, 184, 0.2)',
    text: '#0f172a',
    textSecondary: '#334155',
    textMuted: '#64748b',
    textLight: '#94a3b8',
    border: '#e2e8f0',
    borderFocus: 'rgba(255, 107, 107, 0.45)',
    success: '#10b981',
    successBg: 'rgba(16, 185, 129, 0.1)',
    warning: '#f59e0b',
    warningBg: 'rgba(245, 158, 11, 0.1)',
    error: '#ef4444',
    errorBg: 'rgba(239, 68, 68, 0.08)',
    whatsapp: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)',
    overlay: 'rgba(15, 23, 42, 0.55)',
  },
  shadows: {
    xs: '0 1px 2px rgba(15, 23, 42, 0.04)',
    sm: '0 2px 8px rgba(15, 23, 42, 0.05)',
    md: '0 8px 28px rgba(15, 23, 42, 0.08)',
    lg: '0 16px 48px rgba(15, 23, 42, 0.12)',
    xl: '0 24px 64px rgba(15, 23, 42, 0.16)',
    card: '0 0 0 1px rgba(148,163,184,0.14), 0 4px 24px rgba(15,23,42,0.06)',
    cardHover: '0 0 0 1px rgba(255,107,107,0.12), 0 12px 40px rgba(15,23,42,0.1)',
    glow: '0 8px 32px rgba(255, 107, 107, 0.28)',
    glowSoft: '0 4px 20px rgba(255, 107, 107, 0.18)',
    topbar: '0 1px 0 rgba(148,163,184,0.14), 0 4px 20px rgba(15,23,42,0.05)',
    inner: 'inset 0 1px 2px rgba(15, 23, 42, 0.04)',
    modal: '0 24px 80px rgba(15, 23, 42, 0.22), 0 0 0 1px rgba(148,163,184,0.1)',
  },
  radius: {
    xs: '6px',
    sm: '10px',
    md: '14px',
    lg: '18px',
    xl: '24px',
    pill: '999px',
  },
  font: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  typography: {
    display: '2rem',
    h1: '1.75rem',
    h2: '1.375rem',
    h3: '1.125rem',
    body: '0.9375rem',
    small: '0.8125rem',
    caption: '0.75rem',
  },
  transitions: {
    fast: '0.15s cubic-bezier(0.4, 0, 0.2, 1)',
    base: '0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '0.35s cubic-bezier(0.4, 0, 0.2, 1)',
    spring: '0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  layout: {
    sidebarWidth: 260,
    sidebarCollapsed: 72,
    topbarHeight: 68,
    contentMaxWidth: 1320,
  },
  glass: {
    light: 'rgba(255, 255, 255, 0.92)',
    medium: 'rgba(255, 255, 255, 0.85)',
    blur: 'blur(20px)',
  },
};

export default theme;
